'use client';

var translations = {
    Yes: 'Đồng ý',
    No: 'Không',
    Cancel: 'Huỷ',
    Alert: 'Thông báo'
};

export { translations as default };
//# sourceMappingURL=translation.js.map
